import React from 'react';
import { notification } from 'antd';

interface UndoNotificationProps {
  message: React.ReactNode;
  description: React.ReactNode;
  key: React.Key; // Note: This conflicts with React's reserved prop
  duration?: number;
  onUndo?: () => void;
}

// TODO(tim): does this need to be a react component? Can it just be a function?

const UndoNotification: React.FC<UndoNotificationProps> = ({
  message,
  description,
  key,
  duration = 5,
  onUndo,
}) => {
  const handleUndo = () => {
    onUndo?.();
    notification.destroy(key);
  };

  notification.open({
    message,
    description,
    key,
    duration,
    btn: (
      <button
        onClick={handleUndo}
        style={{
          backgroundColor: 'black',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          fontSize: '12px',
          padding: '4px 10px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        Undo
      </button>
    ),
  });

  return null;
};

export default UndoNotification;
